import type { ReactNode } from 'react';
import { ReloadOutlined } from '@ant-design/icons';

import { Button, Select } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { MOC_KHOANG, type KhoangAi, type MocKhoang } from '../nghiep-vu/khoang';
import { ChonKhoangGio } from './ChonThoiGian';

/**
 * Ô chọn khoảng thời gian của nhóm màn số liệu (Tổng quan, Sử dụng AI, Cảnh báo) — port `ChonKhoang.tsx` native.
 *
 * Tách khỏi bộ lọc của màn Nhật ký thao tác dù trông giống: ô kia chở cả người/đơn vị/hành động và sinh ra hợp đồng
 * tham số khác hẳn (xem `nghiep-vu/khoang.ts`). Gộp hai ô là cách một màn gửi thiếu `den` cho endpoint bắt buộc có.
 */
export function ChonKhoang({
  khoang,
  onDoi,
  onLamMoi,
  dangTai,
  children,
}: {
  khoang: KhoangAi;
  onDoi: (k: KhoangAi) => void;
  onLamMoi: () => void;
  dangTai: boolean;
  /** Ô lọc riêng của từng tab, đặt cạnh ô thời gian trên cùng một hàng. */
  children?: ReactNode;
}) {
  const { t } = useT();
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Select<MocKhoang>
        aria-label={t('nktv.loc.moc')}
        value={khoang.moc}
        onChange={(moc) => onDoi({ ...khoang, moc })}
        className="w-36"
        options={MOC_KHOANG.map((moc) => ({ value: moc, label: t(`nktv.mocKhoang.${moc}`) }))}
      />
      {khoang.moc === 'tuy_chon' && (
        <ChonKhoangGio tu={khoang.tu} den={khoang.den} onDoi={(tu, den) => onDoi({ ...khoang, tu, den })} />
      )}
      {children}
      <Button variant="outline" icon={<ReloadOutlined />} loading={dangTai} onClick={onLamMoi}>
        {t('nktv.loc.lamMoi')}
      </Button>
    </div>
  );
}
